import { Phone, Printer, MapPin } from '@phosphor-icons/react';
import { usePresentation } from '@/context/PresentationContext';

export function useMaskedDoctor() {
    const { maskDoctor } = usePresentation();
    return (name) => maskDoctor(name);
}

/** Phone (tap-to-call), fax and address for a doctor, masked in presentation mode. */
export function DoctorContact({ doctor, compact = false, testidPrefix = 'doctor' }) {
    const { on, maskPhone, maskAddress } = usePresentation();
    const phone = doctor?.phone, fax = doctor?.fax, address = doctor?.address;
    if (!phone && !fax && !address) return <div className="text-xs text-slate-400">No contact details yet</div>;
    return (
        <div className={`flex flex-wrap gap-x-4 gap-y-1 ${compact ? 'text-xs' : 'text-sm'} text-slate-600`}>
            {phone && (on ? (
                <span className="inline-flex items-center gap-1"><Phone size={14} /> {maskPhone(phone)}</span>
            ) : (
                <a data-testid={`${testidPrefix}-phone`} href={`tel:${phone.replace(/[^\d+]/g, '')}`}
                    className="inline-flex items-center gap-1 text-primary hover:underline min-h-[44px] sm:min-h-0 py-2 sm:py-0">
                    <Phone size={14} weight="fill" /> {phone}
                </a>
            ))}
            {fax && <span data-testid={`${testidPrefix}-fax`} className="inline-flex items-center gap-1 sm:py-0 py-2"><Printer size={14} /> Fax {maskPhone(fax)}</span>}
            {address && <span data-testid={`${testidPrefix}-address`} className="inline-flex items-center gap-1 sm:py-0 py-2"><MapPin size={14} /> {maskAddress(address)}</span>}
        </div>
    );
}
